export default __webpack_public_path__ + "static/media/Bonedog.8c5cbca6.png";